import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirRepointService {

  constructor(private http: HttpClient) { }

  /**
   * Save Trial Balance Repoint data
   * Original AngularJS action_code: u7kuxv
   */
  saveTb(
    baseUrl: string,
    jsonSettings: any,
    accounts: any[],
    sourceSystem: string,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=u7kuxv`;

    // Build AngularJS-compatible payload structure (matching original firRepointService.js)
    // Original: params = _.merge({}, GlobalService.globalParams, filterParams);
    let params: any = _.merge({}, globalParams, filterParams);

    // Add required data (matching original order)
    // Original: params = _.extend({jsonObj:jsonObj}, params); params = _.extend({jsonSettings:jsonSettings}, params);
    params.jsonObj = JSON.stringify(accounts);
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.process_name = "FIR_REPOINT_SAVE";

    // Use URLSearchParams for x-www-form-urlencoded (matching AngularJS transformRequest)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Fetch System Account Data
   * Original AngularJS action_code: 4fmxwf
   */
  fetchSystemAcctData(
    baseUrl: string,
    taxYear: string,
    localAcct: string,
    sysAcct: string,
    globalParams: any = {}
  ): Observable<any> {
    const params: any = {
      action_code: '4fmxwf',
      tax_year: taxYear,
      local_acct: localAcct,
      sys_acct: sysAcct
    };

    // Merge with globalParams
    const mergedParams = _.merge({}, globalParams, params);

    return this.http.get<any>(`${baseUrl}/loadJsonObject`, { 
      params: mergedParams,
      withCredentials: true 
    });
  }

  /**
   * Get Default System Account Values (existing repoint data)
   * Original AngularJS action_code: uoezbr
   */
  getDefaultSystemAcctValues(
    baseUrl: string,
    scenario: string,
    jcdKey: string | number,
    taxYear: string,
    sourceSystem: string,
    combinationKey: string | number,
    localAcct: string,
    localChartKey: string | number,
    globalParams: any = {}
  ): Observable<any> {
    const params: any = {
      action_code: 'uoezbr',
      scenario: scenario,
      jcd_key: jcdKey,
      tax_year: taxYear,
      source_sys: sourceSystem,
      combination_key: combinationKey,
      local_acct: localAcct,
      local_chart_key: localChartKey
    };

    // Merge with globalParams
    const mergedParams = _.merge({}, globalParams, params);

    return this.http.get<any>(`${baseUrl}/loadJsonObject`, { 
      params: mergedParams,
      withCredentials: true 
    });
  }

  /**
   * Get System Account Lookup data for dropdowns
   * Original AngularJS action_code: zdfsb6
   */
  getSystemAcctLookup(
    baseUrl: string,
    screenKey: string | number,
    acctType: string | number,
    globalParams: any = {}
  ): Observable<any> {
    const params: any = {
      action_code: 'zdfsb6',
      screen_key: screenKey,
      acct_type: acctType
    };

    // Merge with globalParams
    const mergedParams = _.merge({}, globalParams, params);

    return this.http.get<any>(`${baseUrl}/loadJsonObject`, { 
      params: mergedParams,
      withCredentials: true 
    });
  }
}


